import PaymentMethodForm from "components/PaymentMethod";

const PaymentMethod = () => {
  return <PaymentMethodForm />;
};

export default PaymentMethod;
